export const Config = {
    imgDir: './assets/img/',
    booksFile: './assets/js/booksdata.json',
    content1ApendLevel: '3',
};
